'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@7f-ui/components/accordion/accordion';
import { useClientMediaState } from '@7f-ui/hooks/use-media-state';
import type { NexperienceFragment } from '@data-access/lib/gql/experience/documents';
import { AppExperienceChecklist } from './app-experience-checklist';
import { AppExperienceImportantInformation } from './app-experience-important-information';
type AppExperienceGoodToKnowProps = {
  experience: NexperienceFragment;
  duration: string;
};
export function AppExperienceGoodToKnow(t0) {
  const $ = _c(14);
  const {
    experience,
    duration
  } = t0;
  const isMobile = useClientMediaState("mobile");
  const t1 = !isMobile;
  let t2;
  if ($[0] !== duration || $[1] !== experience) {
    t2 = <AppExperienceImportantInformation experience={experience} duration={duration} />;
    $[0] = duration;
    $[1] = experience;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <Accordion title="Wichtige Informationen" expanded={t1} color="ghost">{t2}</Accordion>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== experience.inclusive) {
    t4 = experience.inclusive.length > 0 && <Accordion title="Das ist alles dabei" color="ghost"><AppExperienceChecklist list={experience.inclusive} /></Accordion>;
    $[6] = experience.inclusive;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== experience.requiredItems) {
    t5 = experience.requiredItems.length > 0 && <Accordion title="Das solltest du mitbringen" color="ghost"><AppExperienceChecklist list={experience.requiredItems} /></Accordion>;
    $[8] = experience.requiredItems;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}